export default __webpack_public_path__ + "static/media/kalahastiDeitie2.a64c08f0.png";